<template>
  <div>
    <v-bottom-sheet v-model="stShowDictionary" v-if="showMobile" hide-overlay>
        <v-sheet class="text-right">
          <v-btn 
            icon
            color="primary"
            class="btn-close"
            @click="showDictionary"
          >
            <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
          </v-btn>
          <Dictionary @close-dictionary="openDictionary" />
        </v-sheet>
    </v-bottom-sheet>
    <v-dialog v-model="stShowDictionary" v-else hide-overlay>
      <v-btn 
        icon
        color="primary"
        class="btn-close"
        @click="showDictionary"
      >
        <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
      </v-btn>
      <Dictionary @close-dictionary="openDictionary" />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Dictionary from '@/components/core/utils/Dictionary.vue'

export default {
  components: {
    Dictionary
  },
  computed: {
    ...mapState({
      stShowDictionary: (state) => state.bookReading.mobileTools.showDictionary,
      showMobile: (state) => state.isMobile,
    })
  },
  methods: {
    ...mapActions('bookReading', [
      'showDictionary'
    ]),
    openDictionary() {
        this.showDictionary()
    },
  },
}
</script>

<style lang="scss">

.v-bottom-sheet{
  position: relative;
  .btn-close{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 10;
  }
}


</style>